import api from "api";
import { apiHeaderOptions } from "./apiHeaderOptions";

const fetchAssetTypes = async () => {
  const url = api.config.getAssetTypes();
  const requestOptions = apiHeaderOptions();
  return fetch(url, requestOptions);
};

const uploadAssets = async (formData: FormData,userId:string,assetId:string) => {
  const url =assetId ? `${api.config.uploadAsset()}${assetId}`: api.config.uploadAsset();
  const method = assetId ? 'PUT' : 'POST';
  return await fetch(url, {
    headers:{
      userId:userId
    },
    method,
    body: formData
  });
};

export const assetUploadService = {
  fetchAssetTypes,
  uploadAssets
};
